// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".related-articles__wrapper .related-articles__heading[data-v-bf335cca]{margin-bottom:10px}.related-articles__wrapper .related-articles__disqus[data-v-bf335cca]{margin-bottom:40px}@media (max-width:767px){.related-articles__wrapper .related-articles__disqus[data-v-bf335cca]{margin-bottom:20px}}.related-articles__wrapper .related-articles__see-more-less[data-v-bf335cca]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
